import { plansCopy } from '../../copy/plans';

// Fills the plan copy templates (copy/plans.ts). Plan names always come from
// the server (spec 7: never hard-coded); when it hasn't said, the copy says
// "your current plan" instead.

/** Replace `{name}` placeholders. */
export function fill(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) =>
    key in values ? String(values[key]) : match);
}

/** Who can change the plan: the Billing page is theirs. */
export function canManageBilling(user: { role?: string; isTenantAdmin?: boolean } | null | undefined): boolean {
  if (!user) return false;
  return user.role === 'Admin' || user.role === 'TenantAdmin' || !!user.isTenantAdmin;
}

/** "Decisions come with the Starter plan." / "Outlook isn't on your current plan." */
export function lockedSentence(feature: string, plural: boolean | undefined, requiredPlan: string | undefined): string {
  const { locked } = plansCopy;
  if (requiredPlan) return fill(plural ? locked.withPlanPlural : locked.withPlan, { feature, plan: requiredPlan });
  return fill(plural ? locked.noPlanPlural : locked.noPlan, { feature });
}

/** "You're on the Personal plan.", or null while the plan isn't known. */
export function currentPlanSentence(plan: string | null | undefined): string | null {
  return plan ? fill(plansCopy.currentPlan, { plan }) : null;
}

/** "1 October", for the AI allowance reset date. */
export function formatResetDate(iso: string | undefined | null): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  // Allowances reset at midnight UTC on the 1st: in a local zone west of
  // Greenwich that instant is still the last day of the month.
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', timeZone: 'UTC' });
}
